import React, { Component } from 'react';
import { connect } from 'react-redux';
import SimpleReactValidator from 'simple-react-validator';
import FileBase64 from 'react-file-base64';
// import { toast } from 'react-toastify';
import ReactTooltip from 'react-tooltip';
import './Profile.scss';
import { Modal } from 'components';

import { UserProfile, IconInformation, IconProfileEditPen } from '../../img';//, IconBtnCopy, IconInformation,IconProfileEdit
import { getProfile } from '../../ducks/auth';
import { updProfile, cPwd, updProfileImg } from '../../ducks/profile';

import SimpleCrypto from 'simple-crypto-js';
const _secretKey = process.env.REACT_APP_SECRET_KEY_FOR_CRYPTO;
const simpleCrypto = new SimpleCrypto(_secretKey);


class Profile extends Component {
  constructor() {
    super();
    this.state = {
      iu: '',
      userInfo: '',
      isPass: false,
      tabType: 'profile'
    };
    this.validator = new SimpleReactValidator();
    this.pwdValidator = new SimpleReactValidator();
  }

  componentDidMount = () => {
    // document.getElementById('page_name').innerHTML = 'Profile';
    this.props.getProfile();
  }

  componentWillReceiveProps = (nextProps) => {
    if (nextProps.password && this.state.isPass == true && this.props.loading == false) {
      if (nextProps.password == 'success') {
        this.state.pd = '';
        this.state.npd = '';
        this.state.openClose = false;
        this.state.isPass = false;
        this.setState(this.state);
        let x = document.getElementById('passId');
        let y = document.getElementById('npd');
        x.type = 'password';
        y.type = 'password';
      }
      this.state.isPass = false;
      this.setState(this.state);
    }
    if (nextProps.profile) {
      this.setState({ un: nextProps.profile.un });
      this.setState({ e: nextProps.profile.e });
      this.setState({ fn: nextProps.profile.fn });
      if (nextProps.profile.iu) {
        this.setState({ iu: nextProps.profile.iu });
      }
      this.setState({ userInfo: nextProps.profile });
    }
  }

  userProfile(files) {
    this.setState({ iu: files.base64 });
    let obj = {
      iu: files.base64
    };
    if (localStorage.getItem('istm') == 'true') {
      obj.istm = true;
    }
    this.props.updProfileImg(obj);
  }

  handleProfileChange = (state, value) => {
    this.setState({ [state]: value });
  }

  updateProfile = () => {
    let that = this;
    if (!that.validator.allValid()) {
      that.validator.showMessages();
      that.forceUpdate();
    }
    else {
      let obj = {
        fn: this.state.fn
      };
      this.props.updProfile(obj);
      localStorage.setItem('username', this.state.fn);
      this.closeModal();
    }
  }

  //showPassword
  showPassword = () => {
    let x = document.getElementById('passId');
    if (x.type === 'password') {
      x.type = 'text';
    } else {
      x.type = 'password';
    }
  }

  //showPassword
  showNewPassword = () => {
    let x = document.getElementById('npd');
    if (x.type === 'password') {
      x.type = 'text';
    } else {
      x.type = 'password';
    }
  }

  updPassword = () => {
    let that = this;
    if (!that.pwdValidator.allValid()) {
      that.pwdValidator.showMessages();
      that.forceUpdate();
    }
    else {
      this.state.isPass = true;
      this.setState(this.state);
      let obj = {
        opd: simpleCrypto.encrypt(this.state.pd),
        pd: simpleCrypto.encrypt(this.state.npd)
      };
      if (localStorage.getItem('istm') == 'true') {
        obj.istm = true;
      }
      this.props.cPwd(obj);
    }
  }

  //open model for edit profile
  ProfileModel = () => {
    return (
      <div className="modal-body ">
        <div className="row row-same-hgt">
          <div className="col-sm-6 col-same-hgt col-profile-left">
            <div className="card-new-add">
              {
                this.state.iu ?
                  <div className="profile-details-user">
                    <img src={this.state.iu} />
                    <div className="upload-btn-profile">
                      <div className="profile-edit-pen">
                        <img src={IconProfileEditPen} alt="" />
                      </div>
                      {
                        <FileBase64
                          multiple={false}
                          onDone={this.userProfile.bind(this)}
                        />
                      }
                    </div>
                  </div>
                  :
                  <div className="profile-details-user">
                    <img src={UserProfile} />
                    <div className="upload-btn-profile">
                      <div className="profile-edit-pen">
                        <img src={IconProfileEditPen} alt="" />
                      </div>
                      {
                        <FileBase64
                          multiple={false}
                          onDone={this.userProfile.bind(this)}
                        />
                      }
                    </div>
                  </div>
              }
            </div>
          </div>
          <div className="col-sm-6 col-same-hgt">
            <div className="edit-profile-right">
              <h4>Edit Profile</h4>
              <form className="form-card" autoComplete="off">
                <div className="nf-group-input mt-20">
                  <label>Full Name</label>
                  <input type="text" name="fn" className="nf-input" value={this.state.fn} id="un" placeholder="Full Name" onChange={(e) => this.handleProfileChange('fn', e.target.value)} />
                  {this.validator.message('Full Name', this.state.fn, 'required')}
                </div>
                <div className="nf-group-input mt-20">
                  <label>Email</label>
                  <input className="nf-input" value={this.state.e} readOnly />
                </div>
                <div className="mt-10 text-center">
                  <button type='button' className="nf-btn nf-btn-default  nf-btn-min15x" onClick={() => this.updateProfile()}>Save</button>
                </div>
                <div className="nf-group-input mt-20">
                  <label>Current Password</label>
                  <div className="input-group  input-group-iconside input-group-currentpw">
                    <input type="password" autoComplete="off" name="pd" className="nf-input" value={this.state.pd} id="passId" placeholder="Enter current password" onChange={(e) => this.handleProfileChange('pd', e.target.value)} />
                    <span className="input-group-btn">
                      <button className="btn btn-default" type="button" onClick={() => this.showPassword()}>
                        <svg xmlns="http://www.w3.org/2000/svg" id="Capa_1" enableBackground="new 0 0 515.556 515.556" height="18" viewBox="0 0 515.556 515.556" width="18"><path d="m257.778 64.444c-119.112 0-220.169 80.774-257.778 193.334 37.609 112.56 138.666 193.333 257.778 193.333s220.169-80.774 257.778-193.333c-37.609-112.56-138.666-193.334-257.778-193.334zm0 322.223c-71.184 0-128.889-57.706-128.889-128.889 0-71.184 57.705-128.889 128.889-128.889s128.889 57.705 128.889 128.889c0 71.182-57.705 128.889-128.889 128.889z" /><path d="m303.347 212.209c25.167 25.167 25.167 65.971 0 91.138s-65.971 25.167-91.138 0-25.167-65.971 0-91.138 65.971-25.167 91.138 0" /></svg>
                      </button>
                    </span>
                  </div>
                  {this.pwdValidator.message('Current Password', this.state.pd, 'required')}
                </div>
                <div className="nf-group-input mt-20">
                  <label>New Password</label>
                  <div className="input-group  input-group-iconside input-group-currentpw">
                    <input type="password" autoComplete="off" name="npd" className="nf-input" value={this.state.npd} id="npd" placeholder="Enter current password" onChange={(e) => this.handleProfileChange('npd', e.target.value)} />
                    <span className="input-group-btn">
                      <button className="btn btn-default" type="button" onClick={() => this.showNewPassword()}>
                        <svg xmlns="http://www.w3.org/2000/svg" id="Capa_1" enableBackground="new 0 0 515.556 515.556" height="18" viewBox="0 0 515.556 515.556" width="18"><path d="m257.778 64.444c-119.112 0-220.169 80.774-257.778 193.334 37.609 112.56 138.666 193.333 257.778 193.333s220.169-80.774 257.778-193.333c-37.609-112.56-138.666-193.334-257.778-193.334zm0 322.223c-71.184 0-128.889-57.706-128.889-128.889 0-71.184 57.705-128.889 128.889-128.889s128.889 57.705 128.889 128.889c0 71.182-57.705 128.889-128.889 128.889z" /><path d="m303.347 212.209c25.167 25.167 25.167 65.971 0 91.138s-65.971 25.167-91.138 0-25.167-65.971 0-91.138 65.971-25.167 91.138 0" /></svg>
                      </button>
                    </span>
                  </div>
                  {this.pwdValidator.message('New Password', this.state.npd, 'required')}
                </div>
                <div className=" mt-10  text-center">
                  <button type='button' className="nf-btn nf-btn-default  nf-btn-min15x" onClick={() => this.updPassword()}>Save</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }

  //open add profile model
  openModal = () => {
    this.setState({ openClose: !this.state.openClose, });
  }

  //close Modal
  closeModal = () => {
    let x = document.getElementById('passId');
    let y = document.getElementById('npd');
    x.type = 'password';
    y.type = 'password';
    this.setState({ openClose: false });
  }

  changeView = (typ) => {
    this.state.tabType = typ;
    this.setState(this.state);
  }

  render() {
    const { openClose } = this.state;
    return (
      <div className="main-container page-profile">
        <div className="container">
          <div className="row">
            <div className="col-md-2 col-xs-12">
              <div className="default-sidebar profile-sidebar">
                <ul className="default-sidebar-list">
                  <li onClick={() => this.changeView('profile')} className={this.state.tabType == 'profile' ? 'active' : ''}>Edit Profile</li>
                  <li onClick={() => this.changeView('password')} className={this.state.tabType == 'password' ? 'active' : ''}>Change Password</li>
                  {/* <li onClick={() => this.changeView('plan')} className={this.state.tabType == 'plan' ? 'active' : ''}>Quota Usage</li> */}
                  {/* <li onClick={() => this.changeView('email')} className={this.state.tabType == 'email' ? 'active' : ''}>Email Subscribe</li> */}
                </ul>
              </div>
            </div>

            <div className="col-md-9 col-xs-12">
              <div className="default-sidebar-content">
                {
                  this.state.tabType == 'profile' &&
                  <div className="dfltsdbar-content dfltsdbar-content-profile">
                    <div className="row">
                      <div className="col-xs-12">
                        <div className="dfltsdbar-sub-title">
                          <h4 className="">Profile Detail </h4>
                        </div>
                        <div className="profile-box profile-details-box">
                          <div className=" mb-25 card-profile">
                            <div className="profile-details-block">
                              <div className="card-new-add">
                                {
                                  this.state.iu ?
                                    <div className="profile-details-user">
                                      <img src={this.state.iu} />
                                      <div className="upload-btn-profile">
                                        <div className="profile-edit-pen">
                                          <img src={IconProfileEditPen} alt="" />
                                        </div>

                                        <FileBase64
                                          multiple={false}
                                          onDone={this.userProfile.bind(this)}
                                        />

                                      </div>
                                    </div>
                                    :
                                    <div className="profile-details-user">
                                      <img src={UserProfile} />
                                      <div className="upload-btn-profile">
                                        <div className="profile-edit-pen">
                                          <img src={IconProfileEditPen} alt="" />
                                        </div>

                                        <FileBase64
                                          multiple={false}
                                          onDone={this.userProfile.bind(this)}
                                        />

                                      </div>
                                    </div>
                                }
                              </div>
                              {
                                localStorage.getItem('istm') == 'true' ?
                                  this.props.profile && this.props.profile.userTeam &&
                                  <div className="profile-details-text">
                                    <h5 className="profile-name mt-15">{this.props.profile.userTeam.fn}</h5>
                                    <span className="profile-mail">{this.props.profile.userTeam.e}</span>
                                  </div>
                                  :
                                  <div className="profile-details-text">
                                    <h5 className="profile-name mt-15">{this.state.userInfo.fn}</h5>
                                    <span className="profile-mail">{this.state.userInfo.e}</span>
                                  </div>
                              }
                            </div>
                          </div>
                          <div className="form-edit-profile mb-30">
                            {/* <div className="row">
                              <div className="col-xs-12">
                                <h3 className="dfltsdbar-part-title">Edit Profile</h3>
                              </div>
                            </div> */}
                            <div className="row">
                              <div className="col-sm-6 col-xs-12">
                                <div className="nf-group-input mt-20">
                                  <label>Full Name</label>
                                  <input type="text" name="fn" className="nf-input" value={this.state.fn} id="un" placeholder="Full Name" onChange={(e) => this.handleProfileChange('fn', e.target.value)} />
                                  {this.validator.message('Full Name', this.state.fn, 'required')}
                                </div>
                              </div>
                              <div className="col-sm-6 col-xs-12">
                                <div className="nf-group-input mt-20">
                                  <label>Email</label>
                                  <input className="nf-input" value={this.state.e} readOnly />
                                </div>
                              </div>
                              <div className="col-xs-12 text-center">
                                <div className="mt-10 text-center">
                                  <button type='button' className="nf-btn nf-btn-default  nf-btn-min15x" onClick={() => this.updateProfile()}>Save</button>
                                </div>
                              </div>
                            </div>
                          </div>
                          {/* API KEY BLOCK */}
                          {/* <div className="profile-box profile-planusage-box">
                            <h3 className="dfltsdbar-part-title mt-5 mb-3">API Key</h3>
                            <figure className="highlight mb-30 text-center">
                              <pre className="text-center">
                                &lt;!-- API BEGIN --&gt;
                                <br />
                                <span>{this.state.ak}</span>
                                <br />
                              &lt;!-- API END --&gt;
                              </pre>
                              <div className="copy-script-upbg" id='copy-pixel'>
                                <div className="copy-script-content" onClick={() => this.copyEndpoint(this.state.ak)} >
                                  <img className="" src={IconBtnCopy} alt="notifly" />
                                  <span>Press here to copy the API</span>
                                </div>
                              </div>
                            </figure>
                          </div> */}
                        </div>
                      </div>
                    </div>
                  </div>
                }

                {
                  this.state.tabType == 'password' &&
                  <div className="dfltsdbar-content dfltsdbar-content-changepw">
                    <div className="row">
                      <div className="col-xs-12">
                        <div className="dfltsdbar-sub-title">
                          <h4 className="">Change Password </h4>
                        </div>
                      </div>
                      <div className="col-xs-12">
                        <div className="row">
                          <div className="col-sm-6 col-xs-12">
                            <div className="nf-group-input mt-20">
                              <label>Current Password</label>
                              <div className="input-group  input-group-iconside input-group-currentpw">
                                <input type="password" autoComplete="off" name="pd" className="nf-input" value={this.state.pd} id="passId" placeholder="Enter current password" onChange={(e) => this.handleProfileChange('pd', e.target.value)} />
                                <span className="input-group-btn">
                                  <button className="btn btn-default" type="button" onClick={() => this.showPassword()}>
                                    <svg xmlns="http://www.w3.org/2000/svg" id="Capa_1" enableBackground="new 0 0 515.556 515.556" height="18" viewBox="0 0 515.556 515.556" width="18">
                                      <path d="m257.778 64.444c-119.112 0-220.169 80.774-257.778 193.334 37.609 112.56 138.666 193.333 257.778 193.333s220.169-80.774 257.778-193.333c-37.609-112.56-138.666-193.334-257.778-193.334zm0 322.223c-71.184 0-128.889-57.706-128.889-128.889 0-71.184 57.705-128.889 128.889-128.889s128.889 57.705 128.889 128.889c0 71.182-57.705 128.889-128.889 128.889z" />
                                      <path d="m303.347 212.209c25.167 25.167 25.167 65.971 0 91.138s-65.971 25.167-91.138 0-25.167-65.971 0-91.138 65.971-25.167 91.138 0" />
                                    </svg>
                                  </button>
                                </span>
                              </div>
                              {this.pwdValidator.message('Current Password', this.state.pd, 'required')}
                            </div>
                          </div>
                          <div className="col-sm-6 col-xs-12">
                            <div className="nf-group-input mt-20">
                              <label>New Password</label>
                              <div className="input-group input-group-iconside input-group-currentpw">
                                <input type="password" autoComplete="off" name="npd" className="nf-input" value={this.state.npd} id="npd" placeholder="Enter new password" onChange={(e) => this.handleProfileChange('npd', e.target.value)} />
                                <span className="input-group-btn">
                                  <button className="btn btn-default" type="button" onClick={() => this.showNewPassword()}>
                                    <svg xmlns="http://www.w3.org/2000/svg" id="Capa_1" enableBackground="new 0 0 515.556 515.556" height="18" viewBox="0 0 515.556 515.556" width="18"><path d="m257.778 64.444c-119.112 0-220.169 80.774-257.778 193.334 37.609 112.56 138.666 193.333 257.778 193.333s220.169-80.774 257.778-193.333c-37.609-112.56-138.666-193.334-257.778-193.334zm0 322.223c-71.184 0-128.889-57.706-128.889-128.889 0-71.184 57.705-128.889 128.889-128.889s128.889 57.705 128.889 128.889c0 71.182-57.705 128.889-128.889 128.889z" /><path d="m303.347 212.209c25.167 25.167 25.167 65.971 0 91.138s-65.971 25.167-91.138 0-25.167-65.971 0-91.138 65.971-25.167 91.138 0" /></svg>
                                  </button>
                                </span>
                              </div>
                              {/* <input type="password" autoComplete="off" name="npd" className="nf-input" value={this.state.npd} id="npd" placeholder="Enter new password" onChange={(e) => this.handleProfileChange('npd', e.target.value)} /> */}
                              {this.pwdValidator.message('New Password', this.state.npd, 'required')}
                            </div>
                          </div>
                          <div className="col-sm-12 col-xs-12">
                            <div className="text-center mb-30">
                              <button type='button' className="nf-btn nf-btn-default  nf-btn-min15x" onClick={() => this.updPassword()}>Save</button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                }

                {
                  this.state.tabType == 'email' &&
                  <div className="dfltsdbar-content dfltsdbar-content-rcvrmail">
                    <div className="row">
                      <div className="col-xs-12">
                        <div className="dfltsdbar-sub-title">
                          <h4 className="">Receive weekly reports on registered email </h4>
                        </div>
                      </div>
                      <div className="col-xs-12">
                        <div className="receive-weekly-block mb-30">
                          {/* <div className="display-useURL-block mt-0">
                            <div className="receive-weekly-left">
                              <span className="default-all-link">Goal<img className="text-line-tooltip" data-tip data-for='gl' src={IconInformation} alt="" /> </span>
                              <div className="tootltip seeting-tooltip">
                                <ReactTooltip id='gl' aria-haspopup='true' role='example'>
                                  <p>Enable this option to receive weekly goal report on registered E-mail address</p>
                                </ReactTooltip>
                              </div>
                            </div>
                            <label className="switch-update mb-1 switch-useabsolute">
                              <input type="checkbox" name="gl" checked={this.state.gl == true ? true : false} onChange={(e) => this.handleProfileChange('gl', e.target.checked)} />
                              <span className="slider round">
                                <samp className="slider-cricle">
                                  <svg className="checkbox-insign checkbox-true" xmlns="http://www.w3.org/2000/svg" width="8" height="6" viewBox="0 0 20.028 14.958">
                                    <path id="checkbox-true" d="M292.95,374.934l-11.8,11.8a.264.264,0,0,1-.376,0l-6.7-6.7a.263.263,0,0,1,0-.375l1.628-1.628a.264.264,0,0,1,.376,0l4.883,4.883,9.982-9.983a.264.264,0,0,1,.376,0l1.627,1.628a.265.265,0,0,1,0,.376Zm0,0" transform="translate(-273.5 -372.352)" fill="#fff" stroke="#fff" strokeWidth="1" />
                                  </svg>
                                  <svg className="checkbox-insign checkbox-false" xmlns="http://www.w3.org/2000/svg" width="7" height="7" viewBox="0 0 18.689 18.69">
                                    <path id="checkbox-false" d="M279.237,367.344l6.338-6.338a.389.389,0,0,0,0-.551l-2.342-2.342a.389.389,0,0,0-.551,0l-6.338,6.338-6.338-6.338a.4.4,0,0,0-.551,0l-2.342,2.342a.389.389,0,0,0,0,.551l6.338,6.338-6.338,6.338a.389.389,0,0,0,0,.551l2.342,2.342a.389.389,0,0,0,.551,0l6.338-6.338,6.338,6.338a.387.387,0,0,0,.551,0l2.342-2.341a.39.39,0,0,0,0-.552Zm0,0" transform="translate(-267 -358)" fill="#fff" />
                                  </svg>
                                </samp>
                              </span>
                            </label>
                          </div> */}
                          <div className="display-useURL-block">
                            <span className="default-all-link">Analytic<img className="text-line-tooltip" data-tip data-for='anltc' src={IconInformation} alt="" /> </span>
                            <div className="tootltip seeting-tooltip">
                              <ReactTooltip id='anltc' aria-haspopup='true' role='example'>
                                <p>Enable this option to receive weekly analytic report on registered E-mail address</p>
                              </ReactTooltip>
                            </div>
                            <label className="switch-update mb-1 switch-useabsolute">
                              <input type="checkbox" name="anltc" checked={this.state.anltc == true ? true : false} onChange={(e) => this.handleProfileChange('anltc', e.target.checked)} />
                              <span className="slider round">
                                <samp className="slider-cricle">
                                  <svg className="checkbox-insign checkbox-true" xmlns="http://www.w3.org/2000/svg" width="8" height="6" viewBox="0 0 20.028 14.958">
                                    <path id="checkbox-true" d="M292.95,374.934l-11.8,11.8a.264.264,0,0,1-.376,0l-6.7-6.7a.263.263,0,0,1,0-.375l1.628-1.628a.264.264,0,0,1,.376,0l4.883,4.883,9.982-9.983a.264.264,0,0,1,.376,0l1.627,1.628a.265.265,0,0,1,0,.376Zm0,0" transform="translate(-273.5 -372.352)" fill="#fff" stroke="#fff" strokeWidth="1" />
                                  </svg>
                                  <svg className="checkbox-insign checkbox-false" xmlns="http://www.w3.org/2000/svg" width="7" height="7" viewBox="0 0 18.689 18.69">
                                    <path id="checkbox-false" d="M279.237,367.344l6.338-6.338a.389.389,0,0,0,0-.551l-2.342-2.342a.389.389,0,0,0-.551,0l-6.338,6.338-6.338-6.338a.4.4,0,0,0-.551,0l-2.342,2.342a.389.389,0,0,0,0,.551l6.338,6.338-6.338,6.338a.389.389,0,0,0,0,.551l2.342,2.342a.389.389,0,0,0,.551,0l6.338-6.338,6.338,6.338a.387.387,0,0,0,.551,0l2.342-2.341a.39.39,0,0,0,0-.552Zm0,0" transform="translate(-267 -358)" fill="#fff" />
                                  </svg>
                                </samp>
                              </span>
                            </label>
                          </div>
                          {/* <div className="display-useURL-block mb-0">
                            <span className="default-all-link">Notification<img className="text-line-tooltip" data-tip data-for='ntf' src={IconInformation} alt="" /> </span>
                            <div className="tootltip seeting-tooltip">
                              <ReactTooltip id='ntf' aria-haspopup='true' role='example'>
                                <p>Enable this option to receive weekly notification performance report on registered E-mail address</p>
                              </ReactTooltip>
                            </div>
                            <label className="switch-update mb-1 switch-useabsolute">
                              <input type="checkbox" name="ntf" checked={this.state.ntf == true ? true : false} onChange={(e) => this.handleProfileChange('ntf', e.target.checked)} />
                              <span className="slider round">
                                <samp className="slider-cricle">
                                  <svg className="checkbox-insign checkbox-true" xmlns="http://www.w3.org/2000/svg" width="8" height="6" viewBox="0 0 20.028 14.958">
                                    <path id="checkbox-true" d="M292.95,374.934l-11.8,11.8a.264.264,0,0,1-.376,0l-6.7-6.7a.263.263,0,0,1,0-.375l1.628-1.628a.264.264,0,0,1,.376,0l4.883,4.883,9.982-9.983a.264.264,0,0,1,.376,0l1.627,1.628a.265.265,0,0,1,0,.376Zm0,0" transform="translate(-273.5 -372.352)" fill="#fff" stroke="#fff" strokeWidth="1" />
                                  </svg>
                                  <svg className="checkbox-insign checkbox-false" xmlns="http://www.w3.org/2000/svg" width="7" height="7" viewBox="0 0 18.689 18.69">
                                    <path id="checkbox-false" d="M279.237,367.344l6.338-6.338a.389.389,0,0,0,0-.551l-2.342-2.342a.389.389,0,0,0-.551,0l-6.338,6.338-6.338-6.338a.4.4,0,0,0-.551,0l-2.342,2.342a.389.389,0,0,0,0,.551l6.338,6.338-6.338,6.338a.389.389,0,0,0,0,.551l2.342,2.342a.389.389,0,0,0,.551,0l6.338-6.338,6.338,6.338a.387.387,0,0,0,.551,0l2.342-2.341a.39.39,0,0,0,0-.552Zm0,0" transform="translate(-267 -358)" fill="#fff" />
                                  </svg>
                                </samp>
                              </span>
                            </label>
                          </div> */}
                        </div>
                      </div>
                    </div>
                  </div>
                }
              </div>
            </div>

          </div>
        </div>

        <Modal
          id='ProfileModel'
          className='ProfileModel'
          title=''
          content={this.ProfileModel()}
          openCloseModal={this.closeModal}
          style={
            {
              modalStyle: {
                display: openClose ? 'block' : 'none',
                opacity: openClose ? 1 : 0
              },
              alignModalStyle: {
                top: '210px'
              }
            }
          }
        />
      </div>
    );
  }
}
const mapStateToProps = state => ({
  profile: state.getIn(['auth', 'profile']),
  loading: state.getIn(['loading', 'state']),
  password: state.getIn(['profile', 'password'])
});

const mapDispatchToProps = {
  updProfile,
  cPwd,
  updProfileImg,
  getProfile,
};

export default connect(mapStateToProps, mapDispatchToProps, null, { withRef: true })(Profile);







{/* <div className="col-xs-12">
  <div className="profile-box profile-details-box">
    <h3 className="page-tab-title title-display mb-2">Profile Detail</h3>
    <div className="card mb-25 card-profile">
      <div className="profile-details-block">
        <div className="profile-details-user">
          {
            this.state.iu ?
              <img src={this.state.iu} alt="profile" />
              :
              <img src={UserProfile} alt="default" />
          }
        </div>
        {
          localStorage.getItem('istm') == 'true' ?
            this.props.profile && this.props.profile.userTeam &&
            <div className="profile-details-text">
              <h5 className="profile-name mt-15">{this.props.profile.userTeam.fn}</h5>
              <span className="profile-mail">{this.props.profile.userTeam.e}</span>
            </div>
            :
            <div className="profile-details-text">
              <h5 className="profile-name mt-15">{this.state.userInfo.fn}</h5>
              <span className="profile-mail">{this.state.userInfo.e}</span>
            </div>
        }
        <div onClick={() => this.openModal()} className="profile-details-edit">
          <img src={IconProfileEdit} alt="" />
          <span >Edit Profile</span>
        </div>
      </div>
    </div>
  </div>
</div> */}


// WEBPACK FOOTER //
// ./src/containers/Profile/Profile.js